import React, {createContext, useCallback, useContext, useState} from "react";
import {isEqual, isFunction} from "lodash";
import {initialFilter} from "../../../../shared/helper/UIHelpers";

const FrameworkManagementUIContext = createContext();

export function useFrameworkManagementUIContext() {
    return useContext(FrameworkManagementUIContext);
}

export function FrameworkManagementUIProvider({frameworkManagementUIEvents, children}) {
    const [queryParams, setQueryParamsBase] = useState(initialFilter);
    const setQueryParams = useCallback(nextQueryParams => {
        setQueryParamsBase(prevQueryParams => {
            if (isFunction(nextQueryParams)) {
                nextQueryParams = nextQueryParams(prevQueryParams);
            }

            if (isEqual(prevQueryParams, nextQueryParams)) {
                return prevQueryParams;
            }

            return nextQueryParams;
        });
    }, []);

    const value = {
        queryParams,
        setQueryParams,
        newFrameworkManagementButtonClick: frameworkManagementUIEvents.newFrameworkManagementButtonClick,
        openChangeFrameworkManagementStatusDialog: frameworkManagementUIEvents.openChangeFrameworkManagementStatusDialog,
        openEditFrameworkManagementDialog: frameworkManagementUIEvents.openEditFrameworkManagementDialog,
    };

    return <FrameworkManagementUIContext.Provider value={value}>{children}</FrameworkManagementUIContext.Provider>;
}
